import { Button, Box } from "@mui/material";
import React, { useContext, useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PageContent, QuestionnaireScreen } from "../../components";
import { AppContext } from "../../context/AppContext";
import { useTranslation } from "react-i18next";
import Notification from "../../components/Notification";

const BarrierQuestions = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { allAnswered, changeCurrentStep } = useContext(AppContext);
  const [dialogOpen, setDialogOpen] = useState(false); // State to manage dialog visibility
  
  const { t } = useTranslation();

  const handleNextClick = useCallback(() => {
    if (allAnswered("0")) {
      navigate("/ScreeningResults");
      changeCurrentStep(2);
    } else {
      setDialogOpen(true); // Open dialog instead of alert
    }
  }, [navigate, changeCurrentStep, allAnswered]);

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close dialog
  };

  return (
    <PageContent title={t("title_initial_screening")}>
      <QuestionnaireScreen questionnaireId={id ?? 0} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginTop: "10px",
        }}
      >
        <Button variant="contained" color="primary" onClick={handleNextClick}>
          {t("button_next")}
        </Button>
      </Box>
      <Notification
        type="warning"
        message={t("please_answer_all_questions")}
        open={dialogOpen}
        onClose={handleCloseDialog}
        centered={true}
      />
    </PageContent>
  );
};

export default BarrierQuestions;
